import React, { useState } from "react";
import {
    Paper,
    Box,
    ToggleButtonGroup, ToggleButton, Typography
} from "@mui/material";
import useApiManager from '../../../../utils/Api/apiManager';
import { useParams } from 'react-router-dom';
import ClosedWonDialog from "./ClosedWonDialog";
import ClosedLostDialog from "./ClosedLostDialog";
import { format } from 'date-fns';

const steps = [
    "Qualification",
    "Needs Analysis",
    "Value Proposition",
    "Identify Decision Makers",
    "Proposal/Price Quote",
    "Negotiation/Review",
    "Closed Won",
    "Closed Lost",
    "Closed Lost Competition"
];

const StageHeader = ({ activeStep, dealDetails }) => {
    const { dealId } = useParams();
    const { patch } = useApiManager();
    const [isClosedWonDialogOpen, setIsClosedWonDialogOpen] = useState(false);
    const [isClosedLostDialogOpen, setIsClosedLostDialogOpen] = useState(false);
    const [pendingStage, setPendingStage] = useState(null);

    const patchDealStage = async (stage, formValues) => {
        try {
            const response = await patch(`/deals/${dealId}/stage`, { stage: stage, ...formValues });
        } catch (error) {
            console.error('Error patching stage:', error);
        } finally {
            window.location.reload();
        }
    };

    const handleStepChange = (event, newStep) => {
        if (newStep === null) return;

        if (newStep === 6) {
            setPendingStage(newStep);
            setIsClosedWonDialogOpen(true); // Open the ClosedWonDialog
        }
        if (newStep === 7 || newStep === 8) {
            setPendingStage(newStep);
            setIsClosedLostDialogOpen(true);
        }
        if (newStep in [1,2,3,4,5]) {
            patchDealStage(newStep);
        }
    };

    const handleClosedWonDialogClose = (confirmed, formValues) => {
        setIsClosedWonDialogOpen(false);
        if (confirmed && pendingStage !== null) {
            patchDealStage(pendingStage, formValues);
        }
        setPendingStage(null); // Clear the pending stage
    };

    const handleClosedLostDialogClose = (confirmed, formValues) => {
        setIsClosedLostDialogOpen(false);
        if (confirmed && pendingStage !== null) {
            patchDealStage(pendingStage, formValues);
        }
        setPendingStage(null); // Clear the pending stage
    };

    return (
        <Paper elevation={0}>
            <Box sx={{ overflowX: "auto", padding: 1 }}>
                {/* Top Section */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    {/* Start Section */}
                    <Box>
                        <Typography variant="subtitle1" fontWeight="bold">
                            START
                        </Typography>
                        <Typography variant="body2">{dealDetails?.createdAt ? format(new Date(dealDetails?.createdAt), 'MMMM do yyyy') : 'No creation date'}</Typography>
                    </Box>

                    {/* Closing Section */}
                    <Box display="flex" alignItems="center">
                        <Box textAlign="right" mr={1}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                CLOSING
                            </Typography>
                            <Typography variant="body2">{dealDetails?.closingDate ? format(new Date(dealDetails?.closingDate), 'MMMM do yyyy') : 'No closing date'}</Typography>
                        </Box>

                    </Box>
                </Box>
                <ToggleButtonGroup
                    value={activeStep}
                    exclusive
                    onChange={handleStepChange}
                    sx={{
                        "& .MuiToggleButton-root": {
                            fontSize: "0.7rem", // Small font
                            padding: "4px 8px", // Small padding
                            minWidth: "80px", // Small button width
                            border: "1px solid #ddd",
                            borderRadius: 0,
                            textTransform: "none",
                        },
                        "& .Mui-selected": {
                            backgroundColor: "#1976d2",
                            color: "#fff",
                            fontWeight: "bold",
                        },
                        "& .MuiToggleButton-root:not(.Mui-selected)": {
                            backgroundColor: "#e7f2ff",
                            color: "#000",
                            opacity: 0.8,
                        },
                        "& .MuiToggleButton-root:hover": {
                            backgroundColor: "#cadbef",
                        },
                        "& .Mui-selected:hover": {
                            backgroundColor: "#1976d2", // Keep selected button color as is
                        },
                    }}
                >
                    {steps.map((label, index) => (
                        <ToggleButton key={index} value={index}>
                            {label}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Box>
            <ClosedWonDialog open={isClosedWonDialogOpen} onClose={handleClosedWonDialogClose} amountPar={dealDetails?.amount} closingDatePar={dealDetails?.closingDate} />
            <ClosedLostDialog open={isClosedLostDialogOpen} onClose={handleClosedLostDialogClose} amountPar={dealDetails?.amount} closingDatePar={dealDetails?.closingDate} />
        </Paper>
    );
};

export default StageHeader;
